<template>
  <ckeditor v-model="data.description" :editor="editor" :config="editorConfig" />
</template>
<script>
import { reactive } from 'vue'
import ClassicEditor from '../Plugin/CKEditor/ckeditor.js'

export default {
  name: 'EmailEditor',
  props: {
    emailSignature: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    //....
    const data = reactive({
      description: props.emailSignature,
    })
    return {
      data,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            // 'underline',
            // 'strikethrough',
            'link',
            // 'alignment',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            // 'fontSize',
            'blockQuote',
            'horizontalLine',
            'insertTable',
            'mediaEmbed',
            'undo',
            'redo',
          ],
        },
        language: 'en',
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
        },
      },
    }
  },
}
</script>
<style>
.ck-editor__editable {
  min-height: 120px;
  line-height: 1.6;
}
</style>
